import BeEndpoints from '../../services/end-points/be-endpoints';
import requestService from '../services/requestService';

const experimentName = {
  TRANSACTION_AIVF_POP_UP_VARIANT: 'transaction_benefits_popup_test_namespace',
  WIDGET_NL_VARIANT: 'widget_nl_state_namespace',
  SOCIAL_MEDIA_CAMPAIGN_FB_VARIANT: 'social_media_campaign_fb_namespace',
  TRANSACTION_AIVF_PAGE_PAN_CARD_POPUP_VARIANT:
    'transaction_aivf_page_pan_card_popup_namespace',
};

const fetchExperimentData = (data, query, overrideHeaders = {}) => {
  const request = {
    method: 'post',
    url: BeEndpoints.GET_AB_TEST_VARIANT,
    data,
  };
  return requestService(
    query,
    request,
    (d) => d.data,
    null,
    null,
    overrideHeaders,
  );
};

export { fetchExperimentData, experimentName };



// WEBPACK FOOTER //
// ./components/transaction/src/api/controllers/experimentController.js